import React from 'react';
import type { PortalBannerAudience, PortalBannerItem, PortalBannerVariant } from '../shared/portalBannerStore';
import './PortalBanner.css';

interface PortalBannerProps {
  items: PortalBannerItem[];
  audience: PortalBannerAudience;
  onDismiss: (id: string) => void;
}

function variantClass(variant?: PortalBannerVariant): string {
  switch (variant) {
    case 'success':
      return 'success';
    case 'warning':
      return 'warning';
    case 'danger':
      return 'danger';
    default:
      return 'info';
  }
}

export const PortalBanner: React.FC<PortalBannerProps> = ({ items, audience, onDismiss }) => {
  const visible = items.filter((item) => !item.audience || item.audience === 'all' || item.audience === audience);
  if (visible.length === 0) {
    return null;
  }

  return (
    <div className="portal-banner-stack" role="status" aria-live="polite">
      {visible.map((item) => (
        <div className={`portal-banner ${variantClass(item.variant)}`} key={item.id}>
          <div className="portal-banner-content">
            {item.title ? <div className="portal-banner-title">{item.title}</div> : null}
            <div className="portal-banner-message">{item.message}</div>
          </div>
          {item.dismissible === false ? null : (
            <button
              type="button"
              className="portal-banner-dismiss"
              onClick={() => onDismiss(item.id)}
              aria-label="Dismiss notification banner"
            >
              x
            </button>
          )}
        </div>
      ))}
    </div>
  );
};
